import React from "react";
import { Edit, SimpleForm, TextInput, required } from "react-admin";
import { Typography, Grid } from "@mui/material";
import { editTitle } from "../../../../customStyles/ra-custom-styles";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const CompanyEdit = () => {
  return (
    <Edit
      title="Кампании"
      mutationMode="pessimistic"
    >
      <Typography sx={editTitle}>Редакция на абонаментна кампания</Typography>
      <SimpleForm>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={10}
          >
            <TextInput
              label="Име на абонаментна кампании"
              source="name_bg"
              validate={required()}
              fullWidth
            />
          </Grid>

          <Grid
            item
            md={6}
            lg={5}
            xl={3}
          >
            <CustomDateInput
              label="Начална дата на абонаментната кампания"
              source="start_date"
              validate={required()}
              fullWidth
            />{" "}
          </Grid>
          <Grid
            item
            md={6}
            lg={5}
            xl={3}
          >
            <CustomDateInput
              label="Крайна дата на абонаментната кампания"
              source="end_date"
              validate={required()}
              fullWidth
            />{" "}
          </Grid>

          <Grid
            item
            md={6}
            lg={5}
            xl={3}
          >
            <CustomDateInput
              label="Дата на начало на абонаментите"
              source="subscription_start_date"
              validate={required()}
              fullWidth
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default CompanyEdit;
